let locales = {
    statusChangesHistory_title:  "Storia delle modifiche",
}

export default locales;